import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { DATE_FORMAT_MMMM_YYYY } from 'constants/formats';

import { DatePickerControl } from 'components/_basic/Form/DatePicker';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ISectionRowProps as IProps } from 'components/BusinessToolForm';

import { getDayJsDate } from 'helpers/formatDates';
import { concatWithDot } from 'helpers/string';

import { ACTIONS_FOR_SUPPORT_NAMES } from '../utils/form';

export const ActionsForLegalSupport: FC<IProps> = memo(({ name, disabled = false }) => {
  const { control, getValues } = useFormContext();
  const { t } = useTranslation();

  const fromDateValue = getValues(concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.START_DATE)) || undefined;
  const toDateValue = getValues(concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE)) || undefined;

  return (
    <BorderedCard>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.ACTION)}
            name={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.ACTION)}
            label={t('legalFrameworkAndRisks.listOfActions.action')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePickerControl
            control={control}
            id={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.START_DATE)}
            name={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.START_DATE)}
            label={t('legalFrameworkAndRisks.listOfActions.start')}
            format={DATE_FORMAT_MMMM_YYYY}
            views={['month', 'year']}
            disabled={disabled}
            maxDate={getDayJsDate(toDateValue)}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePickerControl
            openTo="year"
            control={control}
            id={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE)}
            name={concatWithDot(name, ACTIONS_FOR_SUPPORT_NAMES.EXPECTED_DEADLINE)}
            label={t('legalFrameworkAndRisks.listOfActions.expectedDeadlines')}
            format={DATE_FORMAT_MMMM_YYYY}
            views={['month', 'year']}
            disabled={disabled}
            minDate={getDayJsDate(fromDateValue)}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
